import { render } from "./DOCComponent.vue?vue&type=template&id=15eea5d4"
import script from "./DOCComponent.vue?vue&type=script&lang=js"
export * from "./DOCComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__